var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openDialog.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-lock-open-variant-outline")]),_vm._v(" Reopen Booking ")],1),_c('ReopenBookingDialog',{attrs:{"isOpen":_vm.isOpen},on:{"close":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }